// Token-based signing page. The path MUST match the link built by the API's
// SignatureRequestedNotification: {APP_FRONTEND_URL}/document-sign/{token}.
// Auth is required: the JWT user must be the invited signer (API returns 403 otherwise).
export default {
  path: '/document-sign/:token',
  name: 'document-sign',
  component: () => import('@/views/document-sign/index.vue'),
  meta: { title: 'Sign Document', auth: true, allowAuthenticated: true },
}
